import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n";
import { CalendarCheck, Home, FlaskConical, FileText, ArrowRight } from "lucide-react";

export default function HowItWorks() {
  const { t } = useLang();
  const steps = [
    { icon: CalendarCheck, key: "step1" },
    { icon: Home, key: "step2" },
    { icon: FlaskConical, key: "step3" },
    { icon: FileText, key: "step4" },
  ];
  return (
    <section className="py-20 md:py-28 bg-navy relative overflow-hidden" data-testid="how-it-works-section">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-turq/10 rounded-full blur-3xl" />
      <div className="max-w-7xl mx-auto px-5 md:px-10 relative">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-turq-light">{t("how_label")}</span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-white mt-3 tracking-tight">{t("how_title")}</h2>
        </div>
        <div className="mt-14 grid md:grid-cols-4 gap-6 md:gap-4">
          {steps.map((s, i) => (
            <motion.div key={s.key} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.15 }}
              className="relative text-center" data-testid={`step-${i}`}>
              <div className="relative inline-flex">
                <div className="w-20 h-20 rounded-3xl bg-white/10 backdrop-blur-xl border border-white/20 flex items-center justify-center text-turq-light mx-auto">
                  <s.icon className="w-9 h-9" strokeWidth={1.5} />
                </div>
                <span className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-turq text-white text-sm font-bold flex items-center justify-center">{i + 1}</span>
              </div>
              <h3 className="font-heading font-semibold text-white mt-5 text-lg">{t(s.key)}</h3>
              {i < 3 && <ArrowRight className="hidden md:block absolute top-9 -right-3 w-6 h-6 text-turq-light/40" />}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
